import { render, staticRenderFns } from "./MicrosoftFormEmbed.vue?vue&type=template&id=82769302"
import script from "./MicrosoftFormEmbed.vue?vue&type=script&lang=js"
export * from "./MicrosoftFormEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports